import { SettingLayoutComponentId } from '@starsoft/common/models';
import { BaseCountdownProps } from '../props';
import { useComponentVariant } from '@/hooks/theme/useComponentVariant';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import dynamic from 'next/dynamic';

const GameCountdownV1 = dynamic(() => import('./V1'), { ssr: true });
const GameCountdownV2 = dynamic(() => import('./V2'), { ssr: true });

export default function GameCountdownContent(props: BaseCountdownProps) {
  const version: string = useComponentVariant(ComponentTypeId.GameCountdown);

  switch (version?.toString()) {
    case SettingLayoutComponentId.GameCountdownV1?.toString():
      return <GameCountdownV1 {...props} />;
    case SettingLayoutComponentId.GameCountdownV2?.toString():
      return <GameCountdownV2 {...props} />;
    default:
      return <GameCountdownV1 {...props} />;
  }
}
